import "./App.css";
import { BrowserRouter, Redirect, Route, Switch, useLocation } from "react-router-dom";
import { Bejelentkezes } from "./Bejelentkezes";
import { SzallasLista } from "./SzallasLista";
import { SzallasSingle } from "./SzallasSingle";
export function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route component={WrapperComponent} path="/react-kurzus/bejelentkezesi-felulet-epitese" />
        <Route path="/bejelentkezes" exact component={Bejelentkezes} />

        <Route path="/osszes-szallas" component={SzallasLista} />

        <Route path="/szallas-:szallasId">{(props) => <SzallasSingle id={props.match.params.szallasId} />}</Route>

        <Redirect to={"/bejelentkezes"} />
      </Switch>
    </BrowserRouter>
  );
}

function WrapperComponent(props) {
  const fakeURL = new URLSearchParams(useLocation().search).get("url");

  if (!fakeURL) {
    return <Redirect to={"/react-kurzus/bejelentkezesi-felulet-epitese?url=/bejelentkezes"} />;
  }

  if (fakeURL === "/osszes-szallas") {
    return <SzallasLista {...props} />;
  }
  if (fakeURL === "/bejelentkezes") {
    return <Bejelentkezes {...props} />;
  }
  if (fakeURL.includes("/szallas-")) {
    return <SzallasSingle id={fakeURL.split("-")[1]} />;
  }

  return <Redirect to={"/react-kurzus/bejelentkezesi-felulet-epitese?url=/bejelentkezes"} />;
}
